import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusFlash: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFocusFlash"><Path d="M9 3H3V9H5V5H9V3Z" fill="currentColor"/><Path d="M21 3H15V5H19V9H21V3Z" fill="currentColor"/><Path d="M5 19V15H3V21H9V19H5Z" fill="currentColor"/><Path d="M21 21V15H19V19H15V21H21Z" fill="currentColor"/><Path d="M11.3042 10.9999L13.378 7.68195L11.682 6.62195L7.69574 12.9999H12.6957L10.622 16.3179L12.318 17.3779L16.3042 10.9999H11.3042Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusFlash;
